import { axios, BaseApiUrl } from '../axios_config';


// 获取移动端拣货列表
export const getList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetOutboundPickList`, { ...params }).then(res => res.data);
}

// 获取移动端拣货明细
export const getOutbound = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetOutboundByNo`, { params }).then(res => res.data);
}

// 移动端确认拣货
export const submitPick = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/InsertOutboundPick`, { ...params }).then(res => res.data);
}

// 移动端按票拣货
export const pickOut = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/PickOut`, { ...params }).then(res => res.data);
}

